import React from 'react'
import SiteLayout from '../../component/layout/Layout'
import { Row, Col, Button, Tabs } from 'antd';
import HomeContent from '../../component/home_page_content/home_page_content'
import './home_select.css'
import gameImg from '../../assets/img/Intersection_new.png'
import playar1Logo from '../../assets/img/Playarone-logo-light.svg'
import heart from '../../assets/img/heart.svg'

const HomeSelected = () => {

    const { TabPane } = Tabs;

    return(
        <SiteLayout>
            <div className="home_select_banner">
                <Row>
                    <Col xs={{ span: 24 }}  sm={{ span: 14 }}  md={{ span: 14 }}  lg={{ span: 14 }} xl={{ span: 14 }} className="home_select_left">
                        <Tabs defaultActiveKey="1" >
                            <TabPane tab="overview" key="1">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Sports / Racing</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_details">
                                    <ul>
                                        <li>₦24,000 Prize</li>
                                        <li>September 02</li>
                                        <li>
                                            <div className="level">
                                                18+
                                            </div>
                                        </li>
                                        <li>LV. 2</li>
                                    </ul>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <Button type="primary" className="create">Join Match</Button>
                                    <Button type="primary" className="deposit">Added to my timeline</Button>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="rules & instruction" key="2">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Rules & instruction</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <Button type="primary" className="create">Join Match</Button>
                                    <Button type="primary" className="deposit">Added to my timeline</Button>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="related matches" key="3">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Related matches</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <Button type="primary" className="create">Join Match</Button>
                                    <Button type="primary" className="deposit">Added to my timeline</Button>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="game detail" key="4">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Game detail</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <Button type="primary" className="create">Join Match</Button>
                                    <Button type="primary" className="deposit">Added to my timeline</Button>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                        </Tabs>
                    </Col>
                    <Col xs={{ span: 24 }}  sm={{ span: 10 }}  md={{ span: 10 }}  lg={{ span: 10 }} xl={{ span: 10 }} className="home_select_right">
                        <img src={gameImg} alt=""/>
                    </Col>
                </Row>
            </div>
            <HomeContent /> 
        </SiteLayout>
    );
}

export default HomeSelected